import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './App.css';
import styled from "styled-components";

const theme = {
  blue: {
    default: "#032d60",
    hover: "#aa0000",
  },
  red: {
    default: "#aa0000",
    hover: "#032d60",
  },
};

/* White list the field names */
const includeRegex = /Lyndon|Home Run|Cage/;

const Button = styled.button`
  background-color: ${(props) => theme[props.theme].default};
  color: white;
  padding: 5px 15px;
  border-radius: 5px;
  outline: 0;
  border: 0; 
  text-transform: uppercase;
  margin:auto;
  display:block;
  height: 44px;
  width: 200px;
  cursor: pointer;
  box-shadow: 0px 2px 2px lightgray;
  transition: ease background-color 250ms;
  &:hover {
    background-color: ${(props) => theme[props.theme].hover};
  }
  &:disabled {
    cursor: default;
    opacity: 0.7;
  }
`;

Button.defaultProps = {
  theme: "blue",
};

function fllHome() {
  window.open("https://www.fairportlittleleague.org", "_blank");
}

function fllCal() {
  window.open("https://www.fairportlittleleague.org/schedule", "_blank");
}


function App() {
  const [site, setSite] = useState([]);
  const [fields, setFields] = useState([]);
  const [loading, setLoading] = useState(true);



  const fetchData = () => {

    const siteApiUrl = 'https://fllwebapi-h0dbfkdagxb0esb8.eastus-01.azurewebsites.net/api/status/site';
    const fieldsApiUrl = 'https://fllwebapi-h0dbfkdagxb0esb8.eastus-01.azurewebsites.net/api/status/fields';

    const getSiteStatus = axios.get(siteApiUrl);
    const getFieldsStatus = axios.get(fieldsApiUrl);
    axios.all([getSiteStatus, getFieldsStatus])
      .then(axios.spread((siteResponse, fieldsResponse) => {
        setSite(siteResponse.data);
        setFields(fieldsResponse.data);
      }))
      .catch(error => {
        console.error('Error fetching data:', error);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  useEffect(() => {
    fetchData();
  }
  , []);

  return ( 
    <div className="App">
      
      {loading ? (
            <p><img class="pageCenterImg" src="spinning-softball.gif" width="100" ></img>
            <p class="centerText">Loading field status...</p>
            </p>
          ) 
          : (
              <div>
                <table>
                  <thead>       
                  <tr><th colspan="2" class="headerNoBg"><a target="_new" href="https://www.fairportlittleleague.org"><img src="fll-programs-anim.gif" alt='FLL Logo'></img></a></th></tr>
                  <tr><th colspan="2" class="header"><h1>Field Status</h1></th></tr>
                  </thead>
                  {fields.map(field => ( 
                    <div key={field.name}>
                    { includeRegex.test(field.name) ? ( 
                      <tr>
                        <td class="nameCell"><div>{field.name}</div></td>
                        <td >
                          { field.status === 'OPEN' ? (
                            <div className="statusCell statusOpen">{field.status}</div>
                            ) : (
                            <div className="statusCell statusClosed">{field.status}</div>
                          )}
                        </td>
                      </tr>
                  ) :
                      ('') 
                  }
                    </div>
                  ))} 
                </table>
                <br></br>
                <div><Button onClick={fllHome}>FLL Home Page</Button></div>
                <br></br>
                <div><Button onClick={fllCal}>FLL Calendar</Button></div>
                <br></br>      
                <div><p class="centerText">
                <i>Status Last Changed: {site.lastChanged}</i></p>
                </div>
              </div>
          )}
    </div>
  );
}

export default App;
